import vue from "vue";

const state = {
  activeDs: "",
  dsExportItem: null,
  update: false
};

const mutations = {
  SET_DS_MANAGER_ACTIVE_DS(state, object) {
    vue.set(state, "activeDs", object);
  },
  SET_DS_EXPORT_ITEM(state, object) {
    vue.set(state, "dsExportItem", object);
  },
  SET_UPDATE_DS_TREE(state, value) {
    vue.set(state, "update", value);
  }
};

export default {
  state,
  mutations
};
